import { prefix } from '../../../utils/constant'

export const getFilterResHistory = function (tableId) {
  if(!tableId) return null

  const filterCloumnStr = window.localStorage.getItem(`${prefix}-${tableId}`)

  return filterCloumnStr ? JSON.parse(filterCloumnStr) : null
}

export const setFilterResHistory = function (tableId, filterResHistory) {
  window.localStorage.setItem(`${prefix}-${tableId}`, JSON.stringify(filterResHistory))
}

export const getTableColumnWidthHistory = function (tableId) {
  const tableCloumnWidthStr = window.localStorage.getItem(`${prefix}-${tableId}-width`)

  return tableCloumnWidthStr ? JSON.parse(tableCloumnWidthStr) : null
}

export const setTableColumnWidthHistory = function (tableId, tableCloumnWidthHistory) {
  window.localStorage.setItem(`${prefix}-${tableId}-width`, JSON.stringify(tableCloumnWidthHistory))
}
